module.exports = __webpack_public_path__ + "img/eyein-partner-telus.d5c5b9ba.webp";